<template>
    <div>
      <div v-if="!isLoad">
        <v-main class="bg-[#F7FAFB] dark-bg-default" style="padding: 0px">
          <v-col>
            <v-tabs v-model="tabs" align-with-title :color="$vuetify.theme.currentTheme.primary">
              <v-tab
                :ripple="false"
                v-for="(tab, index) in visibleTabItems"
                :key="index"
                class="mr-12 ml-0"
                :color="$vuetify.theme.currentTheme.primary"
              >
                {{ tab.name }}
              </v-tab>
              <v-tabs-slider color="#32D583"></v-tabs-slider>
            </v-tabs>
          </v-col>
          <component :is="currentTab"></component>
        </v-main>
      </div>
      <div
        v-else
        class="absolute w-full h-screen flex-col items-center flex justify-center"
      >
        <v-progress-circular
          :color="$vuetify.theme.currentTheme.primary"
          indeterminate
          :size="50"
          :width="5"
        ></v-progress-circular>
        <div class="mt-2"><span>Please Wait...</span></div>
      </div>
    </div>
  </template>
  
  <script>
  import Stores from "~/components/Workforce/InventorySettings/Stores.vue";
  import Partners from "~/components/Workforce/InventorySettings/Partners.vue";
  import Products from "~/components/Workforce/InventorySettings/Products.vue";
  import { isModuleFeatureAllowed, hasPermission } from "@/utils/common";
  import permissionData from "@/utils/permissions";
  
  export default {
    name: "InventorySettings",
    layout: "Workforce/default",
    components: {
      Stores,
      Partners,
      Products,
    },
    data() {
      return {
        userData: this.$store.state.wfmPermissions,
        tabs: 0,
        isLoad: true,
      };
    },
    computed: {
      canRead() {
        return hasPermission(this.userData, permissionData.inventoryRead);
      },
      tabItems() {
        return [
          {
            key: "Stores",
            name: "Stores",
            component: "Stores",
            visible: this.canRead && this.isFeatureVisible("MANAGE_STORES"),
          },
          {
            key: "Partners",
            name: "Brands",
            component: "Partners",
            visible: this.canRead && this.isFeatureVisible("MANAGE_PARTNERS"),
          },
          {
            key: "Products",
            name: "Products",
            component: "Products",
            visible:
              this.canRead &&
              this.isFeatureVisible("MANAGE_PARTNER_PRODUCT_RELATION"),
          },
        ];
      },
      visibleTabItems() {
        return this.tabItems.filter((tab) => tab.visible);
      },
      currentTab() {
        return this.visibleTabItems[this.tabs]?.component;
      },
    },
    methods: {
      isFeatureVisible(feature) {
        return isModuleFeatureAllowed("STOCK_MANAGEMENT", feature);
      },
    },
    mounted() {
      this.isLoad = false;
      const firstVisibleTabIndex = this.visibleTabItems.findIndex(
        (tab) => tab.visible
      );
  
      if (firstVisibleTabIndex !== -1) {
        this.tabs = firstVisibleTabIndex;
      }
    },
  };
  </script>
  
  <style scoped>
  .v-tab:before {
    background-color: transparent;
  }
  
  .v-tab {
    font-size: 16px;
  }
  </style>
  